import { render, staticRenderFns, recyclableRender, components } from "./u-dropdown.vue?vue&type=template&id=4c401dc9&"
var renderjs
import script from "./u-dropdown.vue?vue&type=script&lang=js&"
export * from "./u-dropdown.vue?vue&type=script&lang=js&"
import style0 from "./u-dropdown.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../HBuilderX.3.8.4.20230531/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null,
  false,
  components,
  renderjs
)

component.options.__file = "uni_modules/uview-ui/components/u-dropdown/u-dropdown.vue"
export default component.exports